import styled from "styled-components";

export const TraceTimeline = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 14px;
`;

export const TraceRail = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const TraceLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(180deg, rgba(0,247,210,.7), rgba(92,233,255,.25));
  border-radius: 999px;
`;

export const TraceDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: 4px;
  background: ${({ status }) =>
    status === 'ok' ? '#00f7d2' : status === 'pending' ? '#facc15' : '#5ce9ff'};
  box-shadow: 0 0 14px
    ${({ status }) =>
      status === 'ok'
        ? 'rgba(0,247,210,.45)'
        : status === 'pending'
        ? 'rgba(250,204,21,.45)'
        : 'rgba(92,233,255,.45)'};
  z-index: 1;
`;

export const TraceCard = styled.div`
  padding: 14px;
  border-radius: 16px;
  border: 1px solid #1f2937;
  background: radial-gradient(900px 160px at 8% 0%, rgba(0,247,210,.12), transparent 55%), #0d1220;
  margin-bottom: 10px;
`;

export const PhaseHeader = styled.div`
  margin: 16px 0 10px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(92, 233, 255, 0.18);
  background: linear-gradient(180deg, rgba(13, 18, 32, 0.85), rgba(13, 18, 32, 0.55));
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
`;

export const PhaseTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 900;
  color: #e5e7eb;
  flex-wrap: wrap;
`;

export const PhasePill = styled.span`
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #1f2937;
  background: rgba(17, 21, 34, 0.55);
  color: #5ce9ff;
  font-weight: 800;
`;

export const EventActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SmallGhostBtn = styled.button`
  padding: 7px 10px;
  border-radius: 12px;
  border: 1px solid #1f2937;
  background: rgba(13, 18, 32, 0.55);
  color: #e5e7eb;
  cursor: pointer;
  font-weight: 900;
  font-size: 12px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 247, 210, 0.1);
    border-color: rgba(0, 247, 210, 0.35);
  }
`;

export const DetailBox = styled.div`
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(0, 247, 210, 0.16);
  background: rgba(11, 14, 20, 0.55);
  font-size: 13px;
  line-height: 1.45;
  opacity: 0.92;
`;

export const MapBox = styled.div`
  margin-top: 12px;
  height: 180px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #1f2937;
  background: #0d1220;
`;

export const MapFallback = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  opacity: 0.75;
  background: repeating-linear-gradient(45deg, #0d1220, #0d1220 10px, #111827 10px, #111827 20px);
`;

export const ImagesContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
`;

export const TrackingImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #1f2937;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
    border-color: rgba(0, 247, 210, 0.5);
  }
`;

export const DocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
`;

export const DocumentCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #1f2937;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 247, 210, 0.1);
    border-color: #00f7d2;
  }
`;

export const DocumentIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: rgba(0, 247, 210, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 20px;
`;

export const DocumentInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const DocumentName = styled.div`
  color: #e5e7eb;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DocumentHint = styled.div`
  color: #9ca3af;
  font-size: 12px;
  margin-top: 2px;
`;

export const DocumentArrow = styled.div`
  color: #00f7d2;
  font-size: 18px;
`;

export const HashContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HashText = styled.span`
  color: #00f7d2;
  font-family: monospace;
  font-size: 12px;
`;

export const HashIcon = styled.button`
  background: transparent;
  border: none;
  color: #00f7d2;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 247, 210, 0.1);
    transform: scale(1.1);
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  z-index: 10;
`;

export const HistoryModal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const HistoryModalContent = styled.div`
  background: #0d1220;
  border: 1px solid #1f2937;
  border-radius: 16px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px;
  position: relative;
`;

export const HistoryItem = styled.div`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #1f2937;
  background: rgba(255, 255, 255, 0.03);
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const HistoryItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const HistoryItemTitle = styled.div`
  font-size: 16;
  font-weight: 600;
  color: #e5e7eb;
  margin-bottom: 4px;
`;

export const HistoryItemDate = styled.div`
  font-size: 12px;
  color: #9ca3af;
  opacity: 0.7;
`;

export const HistorySection = styled.div`
  margin-bottom: 24px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const HistorySectionTitle = styled.h4`
  font-size: 18px;
  color: #e5e7eb;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionWindowCard = styled.div`
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid #1f2937;
  background: rgba(13, 18, 32, 0.55);
  margin-bottom: 16px;
`;

export const ActionWindowLabel = styled.div`
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.75;
  margin-bottom: 8px;
`;

export const DateRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
`;

export const DateChip = styled.span`
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #1f2937;
  background: #0d1220;
  color: #5ce9ff;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const DateDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${props => props.color || '#5ce9ff'};
  box-shadow: 0 0 8px ${props => props.color || '#5ce9ff'};
`;

export const CountdownChip = styled.span`
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 999px;
  border: ${props => props.status === 'live' ? '1px solid rgba(0,247,210,0.55)' : props.status === 'upcoming' ? '1px solid rgba(92,233,255,0.45)' : props.status === 'ended' ? '1px solid rgba(251,113,133,0.45)' : '1px solid #1f2937'};
  background: ${props => props.status === 'live' ? 'rgba(0,247,210,0.10)' : props.status === 'upcoming' ? 'rgba(92,233,255,0.08)' : props.status === 'ended' ? 'rgba(251,113,133,0.08)' : 'rgba(13,18,32,0.55)'};
  color: ${props => props.status === 'live' ? '#00f7d2' : props.status === 'upcoming' ? '#5ce9ff' : props.status === 'ended' ? '#fca5a5' : '#e5e7eb'};
  font-weight: 900;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
`;
